import type { State, Language } from './types.tsx';

const withoutProjectDefaultLanguage = (languages: Language[], projectDefaultLanguageKey: string) =>
	languages.filter((l) => l.key !== projectDefaultLanguageKey);

const isLanguageUsed = (language: Language) => language.state !== 'unused';
const isLanguageNotUsed = (language: Language) => !isLanguageUsed(language);
const isLanguageActive = (language: Language) => language.state === 'active';

export const getUsedLanguages = (state: State): Language[] =>
	withoutProjectDefaultLanguage(state.data.languages, state.data.projectDefaultLanguage.key).filter(
		isLanguageUsed,
	);

export const getUnusedLanguages = (state: State): Language[] =>
	withoutProjectDefaultLanguage(state.data.languages, state.data.projectDefaultLanguage.key).filter(
		isLanguageNotUsed,
	);

export const getActiveLanguages = (state: State): Language[] =>
	state.data.languages.filter(isLanguageActive);
